import { Component, computed, effect, inject, signal, untracked, ViewChild } from '@angular/core';
import { HttpParams, httpResource } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Params, RouterModule, Router } from '@angular/router';
import { ListComponent } from '@components/list/list.component';
import { environment } from '@environment';
import { ItemListResponse, PlanktonExpedition } from '@models';

@Component({
  selector: 'app-plankton-expedition-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  imports: [ListComponent, MatIconModule, MatListModule, MatPaginatorModule, RouterModule],
})
export class PlanktonExpeditionListComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  route = inject(ActivatedRoute);
  router = inject(Router);

  planktonDatasetId = environment.planktonDatasetId;

  count = signal(0);
  page = signal(0);
  pageSize = signal(10);
  q = signal('');

  httpParams = computed(() => {
    const count = untracked(() => this.count() === 0 || this.page() === 0);
    let params = new HttpParams()
      .set('count', count)
      .set('skip', this.page() * this.pageSize())
      .set('take', this.pageSize())
      .set('eventCount', true);
    if (this.q()) {
      params = params.set('q', this.q());
    }
    return params;
  });

  response = httpResource<ItemListResponse<PlanktonExpedition>>(() => {
    return `${environment.kinkoHost}/plankton/expedition/?${this.httpParams()}`;
  });

  constructor() {
    this.route.queryParams.subscribe((params: Params) => {
      this.page.set(parseInt(params['page']) || 0);
      this.pageSize.set(parseInt(params['pageSize']) || 10);
      this.q.set((params['q'] as string) || '');
    });

    effect(() => {
      if (!this.response.hasValue() || !this.response.value().count) {
        return;
      }

      this.count.set(this.response.value().count);
    });
  }

  onPageEvent(event: PageEvent) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        page: event.pageIndex || undefined,
        pageSize: event.pageSize === 10 ? undefined : event.pageSize,
      },
      replaceUrl: true,
    });
  }

  onSearchEvent(event: Event) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      queryParams: {
        q: (event.target as HTMLInputElement).value.trim() || undefined,
        page: undefined,
      },
      replaceUrl: true,
    });
  }
}
